module.exports = require('../_components/@alicd/next-overlay/lib/index.js');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/overlay/index.js
// module id = 42
// module chunks = 0